import _capitalize from 'lodash/capitalize';
import _merge from 'lodash/merge';

import { TFunction } from '@lyearn/i18n';

import { parseVisibilitySettingsRestrictionConfig } from '../../utils';
import { RestrictedVisibilitySettingsContentProps } from './types';
export const getRestrictedContentCountLabelForGroups: (props: {
  t: TFunction;
}) => RestrictedVisibilitySettingsContentProps['getCountLabel'] =
  ({ t }) =>
  (value) => {
    const { groupIds, contextualGroups } = parseVisibilitySettingsRestrictionConfig(value);
    const count = groupIds.length + contextualGroups.length;

    return count
      ? t('VisibilitySetting:Group', {
          count,
        })
      : '';
  };

export const getGroupsRestrictedContentProps: ({
  t,
  props,
}: {
  t: TFunction;
  props?: Partial<RestrictedVisibilitySettingsContentProps>;
}) => Partial<RestrictedVisibilitySettingsContentProps> = ({ t, props }) =>
  _merge(
    {
      label: t('Common:VisibleTo'),
      getCountLabel: getRestrictedContentCountLabelForGroups({ t }),
      actionLabel: t('Group:Modal.AddGroups'),
    },
    props,
  );

export const getUsersAndGroupsRestrictedContentProps: ({
  t,
  props,
}: {
  t: TFunction;
  props?: Partial<RestrictedVisibilitySettingsContentProps>;
}) => Partial<RestrictedVisibilitySettingsContentProps> = ({ t, props }) =>
  _merge(
    {
      actionLabel: _capitalize(t('Group:Modal.AddPeople')),
      label: t('Common:VisibleTo'),
    },
    props,
  );
